export default __webpack_public_path__ + "assets/budget-alert-d58565033eba3ceb27b71f68500e14e2.svg";